import React from 'react';

function Top() {
  return (
    <div className = "top">
      <h1>Attendence App</h1>
    </div>
  );
}

export default Top;
